import React from 'react';
import DynamicChart from './DynamicChart';
import { HiOutlineX, HiOutlineThumbUp, HiOutlineThumbDown, HiStar, HiOutlineStar } from 'react-icons/hi';
import './AIInsightCard.css';

const AIInsightCard = ({ insight, onDismiss, onPin, isPinned, onActionClick }) => {
  const { id, chartConfig, priority = 'medium' } = insight;

  if (!chartConfig) return null;

  return (
    <div className={`ai-insight-card priority-${priority}`}>
      <div className="insight-card-header">
        <div className="insight-card-title">
          <span className="insight-badge">🤖</span>
          <h4>{chartConfig.title}</h4>
        </div>
        <div className="insight-card-actions">
          <button className="insight-icon-btn pin-btn" onClick={() => onPin && onPin(insight)} title={isPinned ? "Unpin" : "Pin to top"}>
            {isPinned ? <HiStar /> : <HiOutlineStar />}
          </button>
          {onDismiss && (
            <button className="insight-icon-btn" onClick={() => onDismiss(id)} title="Dismiss">
              <HiOutlineX />
            </button>
          )}
        </div>
      </div>
      
      <div className="insight-chart-container">
        <DynamicChart config={chartConfig} compact={true} hideTitle={true} />
      </div>

      <div className="insight-footer">
        <div className="insight-feedback">
          <button className="feedback-btn"><HiOutlineThumbUp /></button>
          <button className="feedback-btn"><HiOutlineThumbDown /></button>
        </div>
        {chartConfig.actions && chartConfig.actions.length > 0 && (
          <div className="insight-action-links">
            {chartConfig.actions.map((action, i) => (
              <button 
                key={i} 
                className="btn-text-primary"
                onClick={() => onActionClick && onActionClick(action)}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AIInsightCard;
